import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIResultsDraftWrapper } from './components/AIResultsDraftWrapper';

async function loadAIResultsDraftStep(): Promise<typeof AIResultsDraftWrapper> {
	return (
		await import(
			/* webpackChunkName: "pages/start-a-petition-steps-ai-results-draft" */ './components/AIResultsDraftWrapper'
		)
	).AIResultsDraftWrapper;
}

export const AIResultsDraftLoader: React.FC = () => {
	return (
		<LazyComponent
			loadComponent={loadAIResultsDraftStep}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
};

export const preloadAIResultsDraftStep = loadAIResultsDraftStep;
